import { useEffect, useMemo } from "react";
import { useNoDataStats } from "@/contexts/NoDataStatsContext.jsx";
import {
  getEffectiveStatsRange,
  parseNoDataStatsByAssetId,
} from "@/lib/no-data-utils.js";

/**
 * Fetch and read cached fleet or asset-scoped no-data stats for a reporting range.
 * @param {{
 *   selectedRange: string,
 *   customStart?: string,
 *   customEnd?: string,
 *   previousRange?: string,
 *   assetId?: string|number,
 *   enabled?: boolean,
 * }} options
 */
export function useNoDataStatsRange({
  selectedRange,
  customStart = "",
  customEnd = "",
  previousRange = selectedRange,
  assetId,
  enabled = true,
}) {
  const effectiveRange = getEffectiveStatsRange(
    selectedRange,
    customStart,
    customEnd,
    previousRange
  );

  const {
    fetchNoDataStatsForRange,
    getNoDataStatsForRange,
    statsRefreshToken,
  } = useNoDataStats();

  useEffect(() => {
    if (!enabled) return;
    fetchNoDataStatsForRange(effectiveRange, customStart, customEnd, assetId);
  }, [
    enabled,
    effectiveRange,
    customStart,
    customEnd,
    assetId,
    statsRefreshToken,
    fetchNoDataStatsForRange,
  ]);

  const entry = getNoDataStatsForRange(
    effectiveRange,
    customStart,
    customEnd,
    assetId
  );

  const statsByAssetId = useMemo(
    () => parseNoDataStatsByAssetId(entry.data),
    [entry.data]
  );

  return { effectiveRange, entry, statsByAssetId };
}
